import api from "./index";

export interface DocumentItem {
  id?: string;
  treatmentId: string;
  beforeImage?: string;
  afterImage?: string;
  medicalDocumentPdf?: string;
  createdOn?: string;
  updatedOn?: string;
}

export interface DocumentsPaginationPayload {
  curPage: number;
  perPage: number;
  sortBy: string;
  direction: "asc" | "desc" | string;
  whereClause: Array<{ key: string; value: string; operator: string }>;
}

export const DocumentsService = {
  // Create with multiple files (max 20 each)
  create: async (
    data: { treatmentId: string },
    beforeImages: File[] = [],
    afterImages: File[] = [],
    medicalPdfs: File[] = []
  ) => {
    const formData = new FormData();
    formData.append("treatmentId", data.treatmentId);

    beforeImages.slice(0, 20).forEach((file) => {
      formData.append("beforeImage", file);
    });

    afterImages.slice(0, 20).forEach((file) => {
      formData.append("afterImage", file);
    });

    medicalPdfs.slice(0, 20).forEach((file) => {
      formData.append("medicalDocumentPdf", file);
    });

    return api.post("/documents/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  update: async (
    id: string,
    data: { treatmentId: string },
    beforeImages: File[] = [],
    afterImages: File[] = [],
    medicalPdfs: File[] = []
  ) => {
    const formData = new FormData();
    formData.append("treatmentId", data.treatmentId);

    beforeImages.slice(0, 20).forEach((file) => {
      formData.append("beforeImage", file);
    });

    afterImages.slice(0, 20).forEach((file) => {
      formData.append("afterImage", file);
    });

    medicalPdfs.slice(0, 20).forEach((file) => {
      formData.append("medicalDocumentPdf", file);
    });

    return api.put(`/documents/update/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  delete: async (id: string) => {
    return api.post(`/documents/delete/${id}`);
  },

  paginate: async (payload: DocumentsPaginationPayload) => {
    return api.post("/documents/pagination", payload);
  },
};

export default DocumentsService;


